import React from 'react';
import { Lightbulb, Users, Target, Zap } from 'lucide-react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { usePortfolio } from '../context/PortfolioContext';

const About = () => {
  const { about, loading } = usePortfolio();
  const [ref, isVisible] = useScrollAnimation(0.1);

  const values = [
    {
      icon: Lightbulb,
      title: "Innovation First",
      description: "Pushing boundaries with cutting-edge IoT and digital transformation solutions."
    },
    {
      icon: Target,
      title: "Impact Driven",
      description: "Focused on creating measurable improvements in safety, efficiency, and growth."
    },
    {
      icon: Users,
      title: "People Centric",
      description: "Building diverse teams and fostering collaborative ecosystems across borders."
    },
    {
      icon: Zap,
      title: "Execution Excellence",
      description: "Turning ambitious visions into operational realities with proven track record."
    }
  ];

  if (loading || !about) return null;

  return (
    <section id="about" className="py-24 md:py-32 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="max-w-3xl mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            About Me
          </h2>
          <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
            {about.bio}
          </p>
        </div>

        {/* Core Values Grid */}
        <div
          ref={ref}
          className="grid md:grid-cols-2 lg:grid-cols-4 gap-8"
        >
          {values.map((value, index) => {
            const Icon = value.icon;
            return (
              <div
                key={index}
                className={`group p-6 rounded-xl bg-gray-50 hover:bg-gray-900 transition-all duration-500 hover:shadow-xl transform hover:-translate-y-2 ${
                  isVisible ? 'animate-fade-in-up' : 'animate-on-scroll'
                }`}
                style={{ animationDelay: `${index * 150}ms` }}
              >
                <div className="mb-4">
                  <Icon
                    size={32}
                    className="text-gray-900 group-hover:text-white transition-colors"
                  />
                </div>
                <h3 className="text-lg font-semibold text-gray-900 group-hover:text-white mb-2 transition-colors">
                  {value.title}
                </h3>
                <p className="text-sm text-gray-600 group-hover:text-gray-300 transition-colors">
                  {value.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default About;